export default __webpack_public_path__ + "static/media/_upgrade_icon.9bb383af.svg";